import { createSlice } from '@reduxjs/toolkit';
import { ViewportInitialState, viewportReducer } from '@printu/viewport';
import { setCanvasRect } from './viewport/actions/modity';
const initialState = Object.assign(Object.assign({}, ViewportInitialState), { padding: { x: 22, y: 22 }, mode: undefined, fitScale: undefined, notYetMounted: true });
function isViewportAction(action) {
    return action.type.indexOf('VIEWPORT_') === 0;
}
export const viewportSlice = createSlice({
    name: 'viewport',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(setCanvasRect.pending.type, state => {
            if (state.notYetMounted === true) {
                delete state.notYetMounted;
            }
            return state;
        });
        builder.addMatcher(isViewportAction, (state, action) => viewportReducer(state, action));
    },
});
